var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.error
    ? _c(
        "div",
        [
          _c(
            "transition-group",
            { attrs: { name: "fade" } },
            _vm._l(_vm.compiledErrors, function(e) {
              return _c(
                "div",
                {
                  key: e.message + "_error",
                  staticClass: "flex-none error-msg d-flex small"
                },
                [
                  _c("span", { staticClass: "my-auto error-icn" }, [
                    _vm._v("!")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "my-auto error-txt" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$te("errors." + e.message)
                            ? _vm.$t(
                                "errors." + e.message,
                                [e.field].concat(e.params)
                              )
                            : e.message
                        ) +
                        "\n            "
                    )
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }